function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment, memo } from 'react';
import { withTheme } from 'styled-components';
import { getProductTypeById } from '@finect/front-resources/Products';
import { dataLayer } from '@finect/front-gtm';
import { GenericTable } from '../../GenericTable';
import { Checkbox } from '../../Forms';
import { Tooltip } from '../../Tooltip';
import { fieldsByProductType } from '../fieldsByProductType';
import { reduceProductFields, parseFields, getLabel, getColumns } from './utils';
import { getEntities, getEntity } from './entities/entities';
import { CellWithCheckbox, CheckboxInner } from './ProductRow/partials';
import { DefaultComponent } from './ProductRow/DefaultComponent';
import { NoAvailableDataComponent } from './ProductRow/NoAvailableDataComponent';
import { CustomizeColumns } from './CustomizeColumns';
export var MAX_PRODUCTS = 5;
export var MAX_CUSTOMIZATION_COLUMNS = 8;
export var ProductsTable = function (_React$Component) {
  _inherits(ProductsTable, _React$Component);
  var _super = _createSuper(ProductsTable);
  function ProductsTable() {
    var _this;
    _classCallCheck(this, ProductsTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      activeFilters: [],
      initialSelection: [],
      selectedFields: [],
      displayFields: [],
      customizationModal: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleCustomization", function (value, customizationFields) {
      var onCustomization = _this.props.onCustomization;
      var allFields = customizationFields.map(function (group) {
        return parseFields(group.fields);
      }).reduce(function (a, b) {
        return [].concat(_toConsumableArray(a), _toConsumableArray(b));
      }, []);
      var newFields = value.map(function (field) {
        return allFields.find(function (it) {
          return it.uniqueId === field;
        });
      });
      var distributorField = allFields.filter(function (_ref) {
        var id = _ref.id;
        return id === 'distributors';
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          hidden: true
        });
      });
      if (!value.find(function (field) {
        return field === 'distributors';
      })) {
        newFields.push.apply(newFields, _toConsumableArray(distributorField));
      }
      dataLayer({
        id: 'ProductsTable',
        type: 'tableColumnsChange',
        params: {
          columns: newFields
        }
      });
      _this.setState({
        customizationModal: false,
        displayFields: newFields
      });
      if (onCustomization) {
        onCustomization({
          productType: _this.getProductType(),
          fields: newFields
        });
      }
      _this.handleRestoreAllFilters();
    });
    _defineProperty(_assertThisInitialized(_this), "handleSavedCustomization", function () {
      _this.setState({
        customizationModal: false,
        displayFields: _this.props.customizationSaved.fields
      });
      _this.handleRestoreAllFilters();
    });
    _defineProperty(_assertThisInitialized(_this), "handleCustomizationRestore", function () {
      _this.setState({
        customizationModal: false,
        displayFields: []
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCustomizationClose", function () {
      _this.setState({
        customizationModal: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCustomizationOpen", function (initialSelection) {
      dataLayer({
        id: 'ProductsTable',
        type: 'customization',
        params: {}
      });
      var parsedFields = parseFields(initialSelection);
      var _ref2 = fieldsByProductType.find(function (item) {
          return item.productType === _this.getProductType().id;
        }) || {},
        _ref2$customizationFi = _ref2.customizationFields,
        customizationFields = _ref2$customizationFi === void 0 ? [] : _ref2$customizationFi;
      var core = parseFields(customizationFields.map(function (_ref3) {
        var fields = _ref3.fields;
        return fields;
      }).flatMap(function (field) {
        return field;
      })).map(function (_ref4) {
        var uniqueId = _ref4.uniqueId;
        return uniqueId;
      });
      var initial = parsedFields.map(function (_ref5) {
        var uniqueId = _ref5.uniqueId;
        return uniqueId;
      }).filter(function (item) {
        return core.includes(item);
      });
      _this.setState({
        initialSelection: initial,
        selectedFields: initial,
        customizationModal: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCustomizationFieldsChange", function (value) {
      if (MAX_CUSTOMIZATION_COLUMNS !== 0) {
        if (value.length <= MAX_CUSTOMIZATION_COLUMNS) {
          _this.setState({
            selectedFields: value
          });
        }
      } else {
        _this.setState({
          selectedFields: value
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getProductType", function () {
      if (_this.props.productType) {
        return _this.props.productType;
      }
      if (!_this.props.products.length) {
        return null;
      }
      var firstModel = getEntity(_this.props.products[0], _this.props.modelType);
      return getProductTypeById(firstModel.product.subtype);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFiltersChange", function (id, items, column) {
      if (items.length === 0) {
        return _this.handleRestoreFilters(id);
      }
      dataLayer({
        id: 'GenericTable',
        type: 'filter',
        params: {
          filterParams: {
            value: items
          },
          column: column
        }
      });
      var itemsId = items.map(function (it) {
        return it.id;
      });
      var newFilter = {
        id: id,
        items: itemsId
      };
      var activeFilters = _this.state.activeFilters;
      var newActiveFilters = [].concat(_toConsumableArray(activeFilters.filter(function (act) {
        return act.id !== id;
      })), [newFilter]);
      _this.setState({
        activeFilters: newActiveFilters
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleRestoreFilters", function (id) {
      var activeFilters = _this.state.activeFilters;
      var newFilters = activeFilters.filter(function (fil) {
        return fil.id !== id;
      });
      _this.setState({
        activeFilters: newFilters
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleRestoreAllFilters", function () {
      _this.setState({
        activeFilters: []
      });
    });
    return _this;
  }
  _createClass(ProductsTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        theme = _this$props.theme,
        fetching = _this$props.fetching,
        fetchingSkeletonItems = _this$props.fetchingSkeletonItems,
        products = _this$props.products,
        fields = _this$props.fields,
        size = _this$props.size,
        fistColumnAsHeader = _this$props.fistColumnAsHeader,
        modelType = _this$props.modelType,
        order = _this$props.order,
        onOrderChange = _this$props.onOrderChange,
        selectable = _this$props.selectable,
        selectedProducts = _this$props.selectedProducts,
        onProductSelect = _this$props.onProductSelect,
        selectedProductsType = _this$props.selectedProductsType,
        productsSubscriptions = _this$props.productsSubscriptions,
        context = _this$props.context,
        withCustomization = _this$props.withCustomization;
      var _this$state = this.state,
        customizationModal = _this$state.customizationModal,
        selectedFields = _this$state.selectedFields,
        displayFields = _this$state.displayFields;
      var productType = this.getProductType();
      var models = getEntities(products, modelType);
      if (!productType) {
        return null;
      }
      var _ref6 = fieldsByProductType.find(function (item) {
          return item.productType === productType.id;
        }) || {},
        _ref6$customizationFi = _ref6.customizationFields,
        customizationFields = _ref6$customizationFi === void 0 ? [] : _ref6$customizationFi,
        _ref6$customizationFi2 = _ref6.customizationFieldsStart,
        customizationFieldsStart = _ref6$customizationFi2 === void 0 ? [] : _ref6$customizationFi2,
        _ref6$customizationFi3 = _ref6.customizationFieldsEnd,
        customizationFieldsEnd = _ref6$customizationFi3 === void 0 ? [] : _ref6$customizationFi3;
      var tableFields = displayFields.length ? [].concat(_toConsumableArray(customizationFieldsStart), _toConsumableArray(displayFields), _toConsumableArray(customizationFieldsEnd)) : fields;
      var parsedFields = parseFields(tableFields);
      var columnFields = reduceProductFields(parsedFields, productType.id);
      var columns = getColumns(productType, columnFields, 'cell');
      var customizationOptions = customizationFields.map(function (group) {
        return {
          title: group.title,
          fields: reduceProductFields(parseFields(group.fields).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              format: 'summary'
            });
          }), productType.id)
        };
      }).map(function (group) {
        return {
          title: group.title,
          options: group.fields.map(function (field) {
            return {
              id: field.params.uniqueId,
              title: getLabel(field, productType)
            };
          })
        };
      });
      var rows = models.map(function (model, rowIndex) {
        var product = model.product;
        var id = product.entity.id;
        var itProductType = getProductTypeById(product.subtype);
        var itColumnFields = reduceProductFields(parsedFields, itProductType.id);
        var cell = itColumnFields.map(function (field, columnIndex) {
          var map = field.map,
            _field$defaultParams = field.defaultParams,
            defaultParams = _field$defaultParams === void 0 ? {} : _field$defaultParams,
            _field$props = field.props,
            props = _field$props === void 0 ? field.component ? function (_ref7) {
              var value = _ref7.value;
              return value;
            } : function (_ref8) {
              var value = _ref8.value;
              return {
                value: value
              };
            } : _field$props,
            _field$component = field.component,
            component = _field$component === void 0 ? DefaultComponent : _field$component,
            _field$type = field.type,
            type = _field$type === void 0 ? 'string' : _field$type,
            mapCompare = field.mapCompare,
            mapValue = field.mapValue,
            _field$parserValue = field.parserValue,
            parserValue = _field$parserValue === void 0 ? function (value) {
              return [{
                id: value,
                label: value,
                icon: null,
                model: value
              }];
            } : _field$parserValue;
          var params = _objectSpread(_objectSpread(_objectSpread({}, defaultParams), field.params), {}, {
            partner: theme.partner
          });
          var getTextAlign = function getTextAlign() {
            var textAlignParam = params.textAlign || null;
            var textAlign = textAlignParam ? textAlignParam : ['number'].includes(type) ? 'right' : columnIndex === 0 ? 'left' : 'center';
            return textAlign;
          };
          var value = map ? map(product, params, model) : null;
          var properties = props({
            value: value,
            productType: productType,
            params: params,
            product: product,
            actions: _this2.props.actions,
            productsSubscriptions: productsSubscriptions,
            position: rowIndex,
            context: context
          });
          var Component = value ? component : NoAvailableDataComponent;
          var stickyColumn = fistColumnAsHeader && columnIndex === 0;
          var tdProps = _objectSpread(_objectSpread({
            as: stickyColumn ? 'th' : 'td'
          }, _objectSpread({}, stickyColumn ? {
            scope: 'row'
          } : {})), {}, {
            textAlign: getTextAlign(),
            wrapValue: params.wrap || null
          });
          var ContentComponent = function ContentComponent() {
            var checkBoxDisabled = id === 1 || selectedProductsType && selectedProductsType.id !== product.subtype || !selectedProducts.find(function (item) {
              return item.entity.id === id;
            }) && selectedProducts.length === MAX_PRODUCTS;
            return React.createElement(Fragment, null, selectable && (itProductType.views || []).includes('comparison') && columnIndex === 0 ? React.createElement(CellWithCheckbox, null, React.createElement(Tooltip, {
              tip: "Compara",
              position: "top",
              from: "left"
            }, React.createElement(CheckboxInner, null, React.createElement(Checkbox, {
              id: "cb-tr-".concat(id),
              name: "cb-tr-".concat(id),
              value: "checked",
              checked: Boolean(selectedProducts.find(function (item) {
                return item.entity.id === id;
              })),
              onChange: function onChange() {
                onProductSelect(product);
              },
              required: false,
              disabled: checkBoxDisabled
            }))), React.createElement("div", null, React.createElement(Component, properties))) : React.createElement(Component, properties));
          };
          var parsedValue = mapValue ? parserValue(mapValue(product, params, model, value)) : undefined;
          return {
            params: tdProps,
            component: React.createElement(ContentComponent, _extends({
              key: "".concat(columnIndex, "-").concat(rowIndex)
            }, properties)),
            _orderableValue: mapCompare ? mapCompare(product, params, model, value) : null,
            value: parsedValue,
            meta: {
              field: field
            }
          };
        });
        return {
          cells: cell,
          match: false
        };
      });
      var customizationActions = this.props.customizationSaved ? [{
        actionText: 'Mi tabla',
        actionCallback: function actionCallback() {
          _this2.handleSavedCustomization();
        }
      }] : [];
      var tableActions = withCustomization && customizationFields.length ? [].concat(customizationActions, [{
        actionText: 'Personalizar',
        actionCallback: function actionCallback() {
          _this2.handleCustomizationOpen(tableFields);
        }
      }]) : [];
      return React.createElement("div", null, customizationModal ? React.createElement(CustomizeColumns, {
        value: selectedFields,
        onChange: this.handleCustomizationFieldsChange,
        onClose: this.handleCustomizationClose,
        onSubmit: function onSubmit(value) {
          _this2.handleCustomization(value, customizationFields);
        },
        subtitle: "Elige las columnas que quieres ver en la tabla.",
        maxCustomizationColumns: MAX_CUSTOMIZATION_COLUMNS,
        options: customizationOptions,
        initialSelection: this.state.initialSelection
      }) : null, React.createElement(GenericTable, {
        zebra: false,
        actions: tableActions,
        fetching: fetching,
        fetchingSkeletonItems: fetchingSkeletonItems,
        columns: columns,
        rows: rows,
        size: size,
        order: order,
        onOrderChange: onOrderChange,
        onFiltersChange: this.handleFiltersChange,
        onRestoreFilters: this.handleRestoreFilters,
        activeFilters: this.state.activeFilters
      }));
    }
  }]);
  return ProductsTable;
}(React.Component);
_defineProperty(ProductsTable, "defaultProps", {
  fetching: false,
  fetchingSkeletonItems: 5,
  products: [],
  selectedProducts: [],
  selectedProductsType: null,
  modelType: 'product',
  selectable: false,
  size: 'small',
  context: [],
  fistColumnAsHeader: true,
  withCustomization: false
});
export default memo(withTheme(ProductsTable));